import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { setAuthLostHandler } from './lib/api';
import { useAuth } from './store/auth';

import { VisitorLayout } from './visitor/VisitorLayout';
import { RackPage } from './visitor/RackPage';
import { ProductPage } from './visitor/ProductPage';
import { CheckoutPage } from './visitor/CheckoutPage';
import { ConfirmationPage } from './visitor/ConfirmationPage';
import { BookingLookupPage } from './visitor/BookingLookupPage';

import { LoginPage } from './admin/LoginPage';
import { AdminLayout } from './admin/AdminLayout';
import { RequireAuth } from './admin/RequireAuth';
import { DashboardPage } from './admin/pages/DashboardPage';
import { ParticipationsPage } from './admin/pages/ParticipationsPage';
import { ParticipationDetailPage } from './admin/pages/ParticipationDetailPage';
import { ProductsPage } from './admin/pages/ProductsPage';
import { ProductDetailPage } from './admin/pages/ProductDetailPage';
import { ImportPage } from './admin/pages/ImportPage';
import { AssignmentsPage } from './admin/pages/AssignmentsPage';
import { BookingsPage } from './admin/pages/BookingsPage';
import { BookingDetailPage } from './admin/pages/BookingDetailPage';
import { VisitorsPage } from './admin/pages/VisitorsPage';
import { AnalyticsPage } from './admin/pages/AnalyticsPage';
import { ReportsPage } from './admin/pages/ReportsPage';
import { QRCodesPage } from './admin/pages/QRCodesPage';
import { UsersPage } from './admin/pages/UsersPage';
import { AuditLogsPage } from './admin/pages/AuditLogsPage';
import { SettingsPage } from './admin/pages/SettingsPage';

export function App() {
  const navigate = useNavigate();
  const bootstrap = useAuth((s) => s.bootstrap);
  const setLost = useAuth((s) => s.setLost);

  useEffect(() => {
    setAuthLostHandler(() => {
      setLost();
      navigate('/admin/login', { replace: true });
    });
    void bootstrap();
  }, [bootstrap, navigate, setLost]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin" replace />} />

      {/* ── Visitor (public) ── */}
      <Route path="/r/:qrToken" element={<VisitorLayout />}>
        <Route index element={<RackPage />} />
        <Route path="p/:assignmentId" element={<ProductPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="confirmed/:bookingNumber" element={<ConfirmationPage />} />
      </Route>
      <Route path="/booking-lookup" element={<BookingLookupPage />} />

      {/* ── Admin ── */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="participations" element={<ParticipationsPage />} />
        <Route path="participations/:id" element={<ParticipationDetailPage />} />
        <Route path="jewellery" element={<ProductsPage />} />
        <Route path="jewellery/:id" element={<ProductDetailPage />} />
        <Route path="import" element={<ImportPage />} />
        <Route path="assignments" element={<AssignmentsPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="bookings/:id" element={<BookingDetailPage />} />
        <Route path="visitors" element={<VisitorsPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="qr-codes" element={<QRCodesPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="audit-logs" element={<AuditLogsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
